import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import '@heurix/design-system/tokens.css';
import '@heurix/design-system/reset.css';
import '@heurix/design-system/style.css';
import { App } from './App';
import { LangProvider } from './i18n/LangContext';

const root = document.getElementById('root');
if (!root) throw new Error('#root not found');

createRoot(root).render(
  <StrictMode>
    <LangProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </LangProvider>
  </StrictMode>,
);
